import { setWrapper } from '../Actions/AnswerAction';
import {
  DISPLAYMESSAGE,
  RANKING,
  WELCOME,
  THANKYOU,
  MULTIPLECHOICEONE,
  MULTIPLECHOICEMULTIPLE,
  MATRIXCHOICEONE,
  MATRIXCHOICEMULTIPLE,
  MATRIXRANKING,
  MATRIXSINGLELINETEXT,
  MULTIPLECHOICESINGLELINETEXT,
  MATRIXDROPDOWN,
  RATING,
  NUMBER,
  validateMessageText,
  verifyMessageText,
  minimumMessageText,
  maximumMessageText,
  verifyOtherMessageText,
  PHONE_SINGLELINETEXT,
  EMAIL_SINGLELINETEXT,
  NETPROMOTORSCORE,
  RATINGSCALE,
} from './TypeValues';
import Exp from '../Expression/expression';
import {
  isNullOrUndefined,
  isArray,
  isString,
  isNumber,
} from '../Utility/index';
import { validateConditionToRoot } from './ConditionValidator';
import { findQuestionInCurrentNode } from './ConditionValidator';
import { removeAnswerValueAny } from '../Utility/ConditionValidator';

// ✅ [Feature Toggle]: สวิตช์เปิด/ปิดการเช็คบังคับตอบช่องข้อความ Other/Append Text อย่างเข้มงวด
// true: บังคับกรอกช่อง text หากติ๊ก Other (แก้ปัญหาที่ Mandatory=false แล้วปล่อยให้ข้ามข้อถ้าเลือกช้อยส์ Other)
// false: ปิดการดัก Validation เฉพาะส่วนที่เพิ่มเติมใหม่ ทำงานตามโครงสร้างเก่า
export const ENABLE_STRICT_TEXT_VALIDATION = true;

const checkSelectedNumberOfChoiceSinglelineText = (d) => {
  return d.filter((e) => e.choiceText.trim() !== '').length;
};
const checkSelectedNumberOfChoice = (d) => {
  return d.filter((e) => e.checkState === true).length;
};
const checkSelectedNumberOfChoiceAndInclude = (d) => {
  let data = d.value.filter((e) => e.checkState === true).length;
  if (d.isIncludeOther === true) data++;
  return data;
};
const setDispatch = (
  dispatch,
  questionElementKey,
  value,
  error,
  isIncludeOther = null,
  IncludeOtherText = null,
) => {
  let data = {
    value: value,
    error: error,
  };
  if (IncludeOtherText) {
    data['IncludeOtherText'] = IncludeOtherText;
  }
  if (!isNullOrUndefined(isIncludeOther)) {
    data['isIncludeOther'] = isIncludeOther;
  }
  dispatch(setWrapper(questionElementKey, data));
  removeAnswerValueAny();
};

const isSelectedAppendTextBoxIsEmpty = (question, answer) => {
  const appendTextList = question.choices.reduce((acc, v, i, arr) => {
    acc[v.elementKey] = v.appendText;
    return acc;
  }, {});
  
  return answer.some(
    (v) =>
      v.checkState === true &&
      appendTextList[v.elementKey] === true &&
      (isNullOrUndefined(v.choiceText) || String(v.choiceText).trim() === '')
  );
};

export const validateRequire = (props, event, dispatch) => {
  const { question, answer } = props;
  //get from element in component
  let value = event.target.value.trim();
  event.target.value = value;
  if (question.mandatory && value === '') {
    setDispatch(dispatch, question.elementKey, value, answer.error); //validateMessageText
    return;
  }
  if (
    !isNullOrUndefined(question.verifyRegularExpression) &&
    question.verifyRegularExpression !== '' &&
    !isNullOrUndefined(value)
  ) {
    if (
      question.verifyRegularExpression &&
      !new RegExp(question.verifyRegularExpression).test(value)
    ) {
      setDispatch(dispatch, question.elementKey, value, answer.error); //verifyMessageText

      return;
    } else {
      setDispatch(dispatch, question.elementKey, value, answer.error); //""
    }
  } else {
    setDispatch(dispatch, question.elementKey, value, answer.error); //""
  }
};

export const validateNumberRequire = (props, event, dispatch) => {
  const { question, answer } = props;
  let value = Number.parseFloat(event.target.value);
  if (question.mandatory && isNaN(value)) {
    value = '';
    setDispatch(dispatch, question.elementKey, value, answer.error);
    return;
  }
  if (!isNaN(value) && question.maximumValue < value) {
    setDispatch(dispatch, question.elementKey, value, answer.error);
    return;
  } else if (!isNaN(value) && question.minimumValue > value) {
    setDispatch(dispatch, question.elementKey, value, answer.error);
    return;
  } else {
    //edit if value is nan
    if (isNaN(value)) {
      value = '';
    }
    setDispatch(dispatch, question.elementKey, value, answer.error);
  }
};
export const validateRequireSetValue = (props, value, dispatch) => {
  const { question, answer } = props;
  if (question.mandatory && value === '') {
    setDispatch(dispatch, question.elementKey, value, answer.error); //verifyMessageText
    return;
  } else {
    setDispatch(dispatch, question.elementKey, value, answer.error); //""
  }
  if (
    !isNullOrUndefined(question.verifyRegularExpression) &&
    question.verifyRegularExpression !== '' &&
    !isNullOrUndefined(value)
  ) {
    if (!new RegExp(question.verifyRegularExpression).test(value)) {
      setDispatch(dispatch, question.elementKey, value, answer.error); //verifyMessageText
      return;
    } else {
      setDispatch(dispatch, question.elementKey, value, answer.error); //
    }
  }
};
export const validateRequireSetValueArrayMatrixAuto = (
  props,
  question,
  value,
  dispatch,
  singleLine = false,
) => {
  let objectElememtKey = [];
  let logValue = [];
  if (Array.isArray(value)) {
    logValue = value.reduce((acc, v, i, arr) => {
      if (objectElememtKey.indexOf(v.questionElementKey) < 0) {
        objectElememtKey.push(v.questionElementKey);

        let data = arr.some((value, index) => {
          if (singleLine) {
            return (
              value.questionElementKey === v.questionElementKey &&
              !isNullOrUndefined(value.value) &&
              value.value.trim() !== ''
            );
          }
          return (
            value.questionElementKey === v.questionElementKey &&
            value.checkState
          );
        });
        acc.push(data);
      }
      return acc;
    }, []);
  }
  if (
    question.mandatory &&
    (logValue.indexOf(false) >= 0 || logValue.length === 0)
  ) {
    setDispatch(dispatch, question.elementKey, value, validateMessageText);
    return false;
  } else {
    setDispatch(dispatch, question.elementKey, value, '');
  }
  return true;
};
export const validateRequireSetValueArrayMatrixRankingAuto = (
  props,
  question,
  value,
  dispatch,
) => {
  let choiceElementKeys = [];
  let logValue = [];
  if (Array.isArray(value)) {
    if (
      question.matrixChoices.length === 0 ||
      question.matrixQuestionItems.length === 0
    ) {
      setDispatch(dispatch, question.elementKey, value, '');
      return true;
    } else if (
      question.matrixChoices.length === question.matrixQuestionItems.length
    ) {
      logValue = value.reduce((acc, v, i, arr) => {
        if (choiceElementKeys.indexOf(v.choiceElementKey) < 0) {
          choiceElementKeys.push(v.choiceElementKey);

          let data = arr.some((value, index) => {
            return (
              value.choiceElementKey === v.choiceElementKey && value.checkState
            );
          });
          acc.push(data);
        }
        return acc;
      }, []);
    } else if (
      question.matrixChoices.length > question.matrixQuestionItems.length
    ) {
      logValue = value.reduce((acc, v, i, arr) => {
        if (choiceElementKeys.indexOf(v.questionElementKey) < 0) {
          choiceElementKeys.push(v.questionElementKey);

          let data = arr.some((value, index) => {
            return (
              value.questionElementKey === v.questionElementKey &&
              value.checkState
            );
          });
          acc.push(data);
        }
        return acc;
      }, []);
    } else if (
      question.matrixChoices.length < question.matrixQuestionItems.length
    ) {
      logValue = value.reduce((acc, v, i, arr) => {
        if (choiceElementKeys.indexOf(v.choiceElementKey) < 0) {
          choiceElementKeys.push(v.choiceElementKey);

          let data = arr.some((value, index) => {
            return (
              value.choiceElementKey === v.choiceElementKey && value.checkState
            );
          });
          acc.push(data);
        }
        return acc;
      }, []);
    }
  }
  if (
    question.mandatory &&
    (logValue.indexOf(false) >= 0 || logValue.length === 0)
  ) {
    setDispatch(dispatch, question.elementKey, value, validateMessageText);
    return false;
  } else {
    setDispatch(dispatch, question.elementKey, value, '');
  }
  return true;
};
export const validateRequireSetValueArrayMatrix = (
  props,
  value,
  dispatch,
  singleLine = false,
) => {
  const { question, answer } = props;
  let objectElememtKey = [];
  let logValue = [];
  if (Array.isArray(value)) {
    logValue = value.reduce((acc, v, i, arr) => {
      if (objectElememtKey.indexOf(v.questionElementKey) < 0) {
        objectElememtKey.push(v.questionElementKey);

        let data = arr.some((value, index) => {
          if (singleLine) {
            return (
              value.questionElementKey === v.questionElementKey &&
              !isNullOrUndefined(value.value) &&
              value.value.trim() !== ''
            );
          }
          return (
            value.questionElementKey === v.questionElementKey &&
            value.checkState
          );
        });
        acc.push(data);
      }
      return acc;
    }, []);
  }
  if (
    question.mandatory &&
    Array.isArray(value) &&
    logValue.indexOf(false) >= 0
  ) {
    setDispatch(dispatch, question.elementKey, value, answer.error); //validateMessageText

    return false;
  } else {
    setDispatch(dispatch, question.elementKey, value, answer.error); //""
  }
};
export const validateRequireSetValueSingleLineMatrix = (
  props,
  value,
  dispatch,
) => {
  const { question } = props;
  let objectElememtKey = [];
  let logValue = [];
  if (Array.isArray(value)) {
    value.filter((v, i) => {
      if (objectElememtKey.indexOf(v.questionElementKey) < 0) {
        objectElememtKey.push(v.questionElementKey);
        logValue.push(
          value.some((vi, index) => {
            return (
              vi.questionElementKey === v.questionElementKey &&
              vi.value.length > 0
            );
          }),
        );
      }
      return true;
    });
  }
  if (
    question.mandatory &&
    Array.isArray(value) &&
    logValue.indexOf(false) >= 0
  ) {
    setDispatch(dispatch, question.elementKey, value, validateMessageText);
    return false;
  } else {
    setDispatch(dispatch, question.elementKey, value, '');
  }
};
export const validateRequireSetValueArray = (props, value, dispatch) => {
  const { answer, question } = props;
  if (!Array.isArray(value) || (Array.isArray(value) && value.length === 0)) {
    setDispatch(dispatch, question.elementKey, value, answer.error); //validateMessageText
    return false;
  } else {
    setDispatch(dispatch, question.elementKey, value, answer.error); //""
  }

  return true;
};
export const validateRequireSetValueMultipleChoiceMultiple = (
  props,
  value,
  dispatch,
) => {
  const { question, answer } = props;
  if (question.includeOther === false) {
    if (question.mandatory === false) {
      if (ENABLE_STRICT_TEXT_VALIDATION && isSelectedAppendTextBoxIsEmpty(question, value)) {
        setDispatch(dispatch, question.elementKey, value, validateMessageText);
        return false;
      }
      setDispatch(dispatch, question.elementKey, value, answer.error); //""
      return true;
    } else if (
      question.mandatory === true &&
      Array.isArray(value) &&
      value.length > 0 &&
      question.requireNumOfChoice <= checkSelectedNumberOfChoice(value) &&
      Object.values(value).some((v) => v.checkState === true)
    ) {
      if (isSelectedAppendTextBoxIsEmpty(question, value)) {
        setDispatch(dispatch, question.elementKey, value, answer.error); //validateMessageText

        return false;
      }
      setDispatch(dispatch, question.elementKey, value, answer.error); //""
      return true;
    } else {
      setDispatch(dispatch, question.elementKey, value, answer.error); //validateMessageText
      return false;
    }
  } else {
    if (question.mandatory === false) {
      if (
        ENABLE_STRICT_TEXT_VALIDATION &&
        !isNullOrUndefined(value) &&
        Array.isArray(value.value) &&
        isSelectedAppendTextBoxIsEmpty(question, value.value)
      ) {
        setDispatch(
          dispatch,
          question.elementKey,
          value.hasOwnProperty('value') ? value.value : [],
          validateMessageText,
          value.hasOwnProperty('isIncludeOther') ? value.isIncludeOther : false,
          value.hasOwnProperty('IncludeOtherText') ? value.IncludeOtherText : '',
        );
        return false;
      }
      
      // บังคับเช็คว่าต้องกรอก Other (Manual, mandatory=false)
      if (
        ENABLE_STRICT_TEXT_VALIDATION &&
        !isNullOrUndefined(value) &&
        value.isIncludeOther === true &&
        (isNullOrUndefined(value.IncludeOtherText) || String(value.IncludeOtherText).trim() === '')
      ) {
        setDispatch(
          dispatch,
          question.elementKey,
          value.hasOwnProperty('value') ? value.value : [],
          verifyOtherMessageText,
          value.hasOwnProperty('isIncludeOther') ? value.isIncludeOther : false,
          value.hasOwnProperty('IncludeOtherText') ? value.IncludeOtherText : '',
        );
        return false;
      }
      
      setDispatch(
        dispatch,
        question.elementKey,
        value.value,
        answer.error, //"",
        value.isIncludeOther,
        value.IncludeOtherText,
      );
      return true;
    } else if (
      question.mandatory === true &&
      !isNullOrUndefined(value) &&
      Array.isArray(value.value) &&
      value.value.length > 0 &&
      question.requireNumOfChoice <=
        checkSelectedNumberOfChoiceAndInclude(value) &&
      ((Object.values(value.value).some((v) => v.checkState === true) &&
        value.isIncludeOther === true &&
        !isNullOrUndefined(value.IncludeOtherText) &&
        String(value.IncludeOtherText).trim() !== '') ||
        (Object.values(value.value).some((v) => v.checkState === true) &&
          value.isIncludeOther === false) ||
        (Object.values(value.value).some((v) => v.checkState === false) &&
          value.isIncludeOther === true &&
          !isNullOrUndefined(value.IncludeOtherText) &&
          String(value.IncludeOtherText).trim() !== ''))
    ) {
      if (isSelectedAppendTextBoxIsEmpty(question, value.value)) {
        setDispatch(
          dispatch,
          question.elementKey,
          value.hasOwnProperty('value') ? value.value : [],
          answer.error, //verifyOtherMessageText
          value.hasOwnProperty('isIncludeOther') ? value.isIncludeOther : false,
          value.hasOwnProperty('IncludeOtherText')
            ? value.IncludeOtherText
            : '',
        );
        return false;
      }
      setDispatch(
        dispatch,
        question.elementKey,
        value.value,
        answer.error, //"",
        value.isIncludeOther,
        value.IncludeOtherText,
      );
      return true;
    } else {
      setDispatch(
        dispatch,
        question.elementKey,
        value.hasOwnProperty('value') ? value.value : [],
        answer.error, //validateMessageText,
        value.hasOwnProperty('isIncludeOther') ? value.isIncludeOther : false,
        value.hasOwnProperty('IncludeOtherText') ? value.IncludeOtherText : '',
      );
      return false;
    }
  }
};
export const validateRequireSetValueMultipleChoiceOne = (
  props,
  value,
  dispatch,
) => {
  const { question, answer } = props;
  if (question.includeOther === false) {
    if (question.mandatory === false) {
      setDispatch(
        dispatch,
        question.elementKey,
        value,
        answer.error, //""
      );

      return true;
    } else if (
      question.mandatory &&
      Array.isArray(value) &&
      value.length > 0 &&
      value.some((v) => v.checkState === true)
    ) {
      if (isSelectedAppendTextBoxIsEmpty(question, value)) {
        setDispatch(dispatch, question.elementKey, value, answer.error); //verifyOtherMessageText
        return false;
      }
      setDispatch(dispatch, question.elementKey, value, answer.error); //""
      return true;
    } else {
      setDispatch(dispatch, question.elementKey, value, answer.error); //validateMessageText
      return false;
    }
  } else {
    if (question.mandatory === false) {
      setDispatch(
        dispatch,
        question.elementKey,
        value.value,
        answer.error, //"",
        value.isIncludeOther,
        value.IncludeOtherText,
      );

      return true;
    } else if (
      question.mandatory &&
      !isNullOrUndefined(value) &&
      Array.isArray(value.value) &&
      value.value.length > 0 &&
      (Object.values(value.value).some((v) => v.checkState === true) ||
        (value.isIncludeOther === true &&
          !isNullOrUndefined(value.IncludeOtherText) &&
          value.IncludeOtherText !== ''))
    ) {
      if (isSelectedAppendTextBoxIsEmpty(question, value.value)) {
        setDispatch(
          dispatch,
          question.elementKey,
          value.hasOwnProperty('value') ? value.value : [],
          answer.error,
          value.hasOwnProperty('isIncludeOther') ? value.isIncludeOther : false,
          value.hasOwnProperty('IncludeOtherText')
            ? value.IncludeOtherText
            : '',
        );
        //validateMessageText
        return false;
      }
      setDispatch(
        dispatch,
        question.elementKey,
        value.value,
        answer.error, //""
        value.isIncludeOther,
        value.IncludeOtherText,
      );
      return true;
    } else {
      setDispatch(
        dispatch,
        question.elementKey,
        value.hasOwnProperty('value') ? value.value : [],
        answer.error, //validateMessageText
        value.hasOwnProperty('isIncludeOther') ? value.isIncludeOther : false,
        value.hasOwnProperty('IncludeOtherText') ? value.IncludeOtherText : '',
      );
      return false;
    }
  }
};
export const validateRequireSetValueMultipleChoiceMultipleAuto = (
  props,
  question,
  value,
  dispatch,
) => {
  if (question.includeOther === false) {
    if (question.mandatory === false) {
      if (ENABLE_STRICT_TEXT_VALIDATION && isSelectedAppendTextBoxIsEmpty(question, value)) {
        setDispatch(dispatch, question.elementKey, value, validateMessageText);
        return false;
      }
      setDispatch(dispatch, question.elementKey, value, ''); //""
      return true;
    } else if (
      question.mandatory === true &&
      Array.isArray(value) &&
      value.length > 0 &&
      question.requireNumOfChoice <= checkSelectedNumberOfChoice(value) &&
      value.some((v) => v.checkState === true)
    ) {
      if (isSelectedAppendTextBoxIsEmpty(question, value)) {
        setDispatch(dispatch, question.elementKey, value, validateMessageText);

        return false;
      }
      setDispatch(dispatch, question.elementKey, value, '');

      return true;
    } else {
      setDispatch(dispatch, question.elementKey, value, validateMessageText);

      return false;
    }
  } else {
    // บังคับเช็ค Append Text แม้ว่า mandatory === false
    if (
      ENABLE_STRICT_TEXT_VALIDATION &&
      question.mandatory === false &&
      !isNullOrUndefined(value) &&
      Array.isArray(value.value) &&
      isSelectedAppendTextBoxIsEmpty(question, value.value)
    ) {
      setDispatch(
        dispatch,
        question.elementKey,
        value.hasOwnProperty('value') ? value.value : [],
        validateMessageText,
        value.hasOwnProperty('isIncludeOther') ? value.isIncludeOther : false,
        value.hasOwnProperty('IncludeOtherText') ? value.IncludeOtherText : '',
      );
      return false;
    }

    if (
      question.mandatory === false &&
      !isNullOrUndefined(value) &&
      Array.isArray(value.value) &&
      value.isIncludeOther === true
    ) {
      if (
        (!isNullOrUndefined(question.verifyOtherRegularExpression) &&
          !new RegExp(question.verifyOtherRegularExpression).test(
            value.IncludeOtherText,
          )) ||
        (!isNullOrUndefined(question.verifyOtherRegularExpression) &&
          isNullOrUndefined(value.IncludeOtherText))
      ) {
        setDispatch(
          dispatch,
          question.elementKey,
          value.hasOwnProperty('value') ? value.value : [],
          verifyOtherMessageText,
          value.hasOwnProperty('isIncludeOther') ? value.isIncludeOther : false,
          value.hasOwnProperty('IncludeOtherText')
            ? value.IncludeOtherText
            : '',
        );
        return false;
      }
      
      // บังคับเช็คการเว้นว่างของ IncludeOtherText (Auto, mandatory=false)
      if (ENABLE_STRICT_TEXT_VALIDATION && (isNullOrUndefined(value.IncludeOtherText) || String(value.IncludeOtherText).trim() === '')) {
        setDispatch(
          dispatch,
          question.elementKey,
          value.hasOwnProperty('value') ? value.value : [],
          verifyOtherMessageText,
          value.hasOwnProperty('isIncludeOther') ? value.isIncludeOther : false,
          value.hasOwnProperty('IncludeOtherText') ? value.IncludeOtherText : '',
        );
        return false;
      }

      setDispatch(
        dispatch,
        question.elementKey,
        value.value,
        '',
        value.isIncludeOther,
        value.IncludeOtherText,
      );

      return true;
    } else if (
      question.mandatory === false &&
      !isNullOrUndefined(value) &&
      Array.isArray(value.value) &&
      value.isIncludeOther === false
    ) {
      // fix bug not mandatory and uncheck can go to next question 8/23/2018
      setDispatch(
        dispatch,
        question.elementKey,
        value.value,
        '',
        value.isIncludeOther,
        value.IncludeOtherText,
      );
      return true;
    } else if (
      question.mandatory === true &&
      !isNullOrUndefined(value) &&
      Array.isArray(value.value) &&
      value.isIncludeOther === true
    ) {
      if (
        value.value.length > 0 &&
        question.requireNumOfChoice >
          checkSelectedNumberOfChoiceAndInclude(value)
      ) {
        setDispatch(
          dispatch,
          question.elementKey,
          value.hasOwnProperty('value') ? value.value : [],
          validateMessageText,
          value.hasOwnProperty('isIncludeOther') ? value.isIncludeOther : false,
          value.hasOwnProperty('IncludeOtherText')
            ? value.IncludeOtherText
            : '',
        );
        return false;
      }
      if (
        (!isNullOrUndefined(question.verifyOtherRegularExpression) &&
          !new RegExp(question.verifyOtherRegularExpression).test(
            value.IncludeOtherText,
          )) ||
        (!isNullOrUndefined(question.verifyOtherRegularExpression) &&
          isNullOrUndefined(value.IncludeOtherText))
      ) {
        setDispatch(
          dispatch,
          question.elementKey,
          value.hasOwnProperty('value') ? value.value : [],
          verifyOtherMessageText,
          value.hasOwnProperty('isIncludeOther') ? value.isIncludeOther : false,
          value.hasOwnProperty('IncludeOtherText')
            ? value.IncludeOtherText
            : '',
        );
        return false;
      }
      
      // บังคับเช็คการเว้นว่างของ IncludeOtherText (Auto, mandatory=true)
      if (ENABLE_STRICT_TEXT_VALIDATION && (isNullOrUndefined(value.IncludeOtherText) || String(value.IncludeOtherText).trim() === '')) {
        setDispatch(
          dispatch,
          question.elementKey,
          value.hasOwnProperty('value') ? value.value : [],
          verifyOtherMessageText,
          value.hasOwnProperty('isIncludeOther') ? value.isIncludeOther : false,
          value.hasOwnProperty('IncludeOtherText') ? value.IncludeOtherText : '',
        );
        return false;
      }

      setDispatch(
        dispatch,
        question.elementKey,
        value.value,
        '',
        value.isIncludeOther,
        value.IncludeOtherText,
      );
      return true;
    } else if (
      question.mandatory === true &&
      !isNullOrUndefined(value) &&
      Array.isArray(value.value) &&
      value.value.length > 0 &&
      question.requireNumOfChoice <=
        checkSelectedNumberOfChoiceAndInclude(value) &&
      ((Object.values(value.value).some((v) => v.checkState === true) &&
        value.isIncludeOther === true &&
        !isNullOrUndefined(value.IncludeOtherText) &&
        String(value.IncludeOtherText).trim() !== '') ||
        (Object.values(value.value).some((v) => v.checkState === true) &&
          value.isIncludeOther === false) ||
        (Object.values(value.value).some((v) => v.checkState === false) &&
          value.isIncludeOther === true &&
          !isNullOrUndefined(value.IncludeOtherText) &&
          String(value.IncludeOtherText).trim() !== ''))
    ) {
      if (
        (!isNullOrUndefined(question.verifyOtherRegularExpression) &&
          value.isIncludeOther === true &&
          !new RegExp(question.verifyOtherRegularExpression).test(
            value.IncludeOtherText,
          )) ||
        (!isNullOrUndefined(question.verifyOtherRegularExpression) &&
          isNullOrUndefined(value.IncludeOtherText) &&
          value.isIncludeOther === true)
      ) {
        setDispatch(
          dispatch,
          question.elementKey,
          value.hasOwnProperty('value') ? value.value : [],
          verifyOtherMessageText,
          value.hasOwnProperty('isIncludeOther') ? value.isIncludeOther : false,
          value.hasOwnProperty('IncludeOtherText')
            ? value.IncludeOtherText
            : '',
        );
        return false;
      }
      if (isSelectedAppendTextBoxIsEmpty(question, value.value)) {
        setDispatch(
          dispatch,
          question.elementKey,
          value.hasOwnProperty('value') ? value.value : [],
          verifyOtherMessageText,
          value.hasOwnProperty('isIncludeOther') ? value.isIncludeOther : false,
          value.hasOwnProperty('IncludeOtherText')
            ? value.IncludeOtherText
            : '',
        );

        return false;
      }
      setDispatch(
        dispatch,
        question.elementKey,
        value.value,
        '',
        value.isIncludeOther,
        value.IncludeOtherText,
      );

      return true;
    } else {
      if (
        !isNullOrUndefined(question.verifyOtherRegularExpression) &&
        isNullOrUndefined(value.IncludeOtherText) &&
        value.isIncludeOther === true
      ) {
        setDispatch(
          dispatch,
          question.elementKey,
          value.hasOwnProperty('value') ? value.value : [],
          validateMessageText,
          value.hasOwnProperty('isIncludeOther') ? value.isIncludeOther : false,
          value.hasOwnProperty('IncludeOtherText')
            ? value.IncludeOtherText
            : '',
        );
        return false;
      }
      if (
        !isNullOrUndefined(question.verifyOtherRegularExpression) &&
        value.isIncludeOther === true &&
        !new RegExp(question.verifyOtherRegularExpression).test(
          value.IncludeOtherText,
        )
      ) {
        setDispatch(
          dispatch,
          question.elementKey,
          value.hasOwnProperty('value') ? value.value : [],
          verifyOtherMessageText,
          value.hasOwnProperty('isIncludeOther') ? value.isIncludeOther : false,
          value.hasOwnProperty('IncludeOtherText')
            ? value.IncludeOtherText
            : '',
        );
        return false;
      }
      setDispatch(
        dispatch,
        question.elementKey,
        value.hasOwnProperty('value') ? value.value : [],
        validateMessageText,
        value.hasOwnProperty('isIncludeOther') ? value.isIncludeOther : false,
        value.hasOwnProperty('IncludeOtherText') ? value.IncludeOtherText : '',
      );

      return false;
    }
  }
};
export const validateRequireSetValueMultipleChoiceSinglelineTextAuto = (
  props,
  question,
  value,
  dispatch,
) => {
  if (question.mandatory === false) {
    setDispatch(dispatch, question.elementKey, value, '');
    return true;
  } else if (
    question.mandatory === true &&
    Array.isArray(value) &&
    value.length > 0 &&
    question.requiredMinimumAnswer <=
      checkSelectedNumberOfChoiceSinglelineText(value)
  ) {
    setDispatch(dispatch, question.elementKey, value, '');

    return true;
  } else {
    setDispatch(dispatch, question.elementKey, value, validateMessageText);

    return false;
  }
};

export const validateRequireSetValueMultipleChoiceOneAuto = (
  props,
  question,
  value,
  dispatch,
) => {
  if (question.includeOther === false) {
    if (question.mandatory === false) {
      setDispatch(dispatch, question.elementKey, value, '');
      return true;
    } else if (
      question.mandatory === true &&
      Array.isArray(value) &&
      value.length > 0 &&
      Object.values(value).some((v) => v.checkState === true)
    ) {
      if (isSelectedAppendTextBoxIsEmpty(question, value)) {
        setDispatch(dispatch, question.elementKey, value, validateMessageText);

        return false;
      }
      setDispatch(dispatch, question.elementKey, value, '');
      return true;
    } else {
      setDispatch(dispatch, question.elementKey, value, validateMessageText);
      return false;
    }
  } else {
    if (
      !isNullOrUndefined(value) &&
      Array.isArray(value.value) &&
      value.isIncludeOther === true
    ) {
      if (
        !isNullOrUndefined(question.verifyOtherRegularExpression) &&
        isNullOrUndefined(value.IncludeOtherText)
      ) {
        setDispatch(
          dispatch,
          question.elementKey,
          value.hasOwnProperty('value') ? value.value : [],
          verifyOtherMessageText,
          value.hasOwnProperty('isIncludeOther') ? value.isIncludeOther : false,
          value.hasOwnProperty('IncludeOtherText')
            ? value.IncludeOtherText
            : '',
        );
        return false;
      }
      if (
        !isNullOrUndefined(question.verifyOtherRegularExpression) &&
        !new RegExp(question.verifyOtherRegularExpression).test(
          value.IncludeOtherText,
        )
      ) {
        setDispatch(
          dispatch,
          question.elementKey,
          value.hasOwnProperty('value') ? value.value : [],
          verifyOtherMessageText,
          value.hasOwnProperty('isIncludeOther') ? value.isIncludeOther : false,
          value.hasOwnProperty('IncludeOtherText')
            ? value.IncludeOtherText
            : '',
        );
        return false;
      }
      setDispatch(
        dispatch,
        question.elementKey,
        value.value,
        '',
        value.isIncludeOther,
        value.IncludeOtherText,
      );

      return true;
    } else if (
      question.mandatory === false &&
      !isNullOrUndefined(value) &&
      Array.isArray(value.value) &&
      value.value.length > 0 &&
      Object.values(value.value).some((v) => v.checkState === true) &&
      value.isIncludeOther === false
    ) {
      setDispatch(
        dispatch,
        question.elementKey,
        value.value,
        '',
        value.isIncludeOther,
        value.IncludeOtherText,
      );

      return true;
    } else if (
      question.mandatory &&
      !isNullOrUndefined(value) &&
      Array.isArray(value.value) &&
      value.value.length > 0 &&
      (Object.values(value.value).some((v) => v.checkState === true) ||
        (value.isIncludeOther === true &&
          !isNullOrUndefined(value.IncludeOtherText) &&
          value.IncludeOtherText !== ''))
    ) {
      if (isSelectedAppendTextBoxIsEmpty(question, value.value)) {
        setDispatch(
          dispatch,
          question.elementKey,
          value.hasOwnProperty('value') ? value.value : [],
          verifyOtherMessageText,
          value.hasOwnProperty('isIncludeOther') ? value.isIncludeOther : false,
          value.hasOwnProperty('IncludeOtherText')
            ? value.IncludeOtherText
            : '',
        );
        return false;
      }
      setDispatch(
        dispatch,
        question.elementKey,
        value.value,
        '',
        value.isIncludeOther,
        value.IncludeOtherText,
      );

      return true;
    } else if (
      question.mandatory === false &&
      !isNullOrUndefined(value) &&
      Array.isArray(value.value) &&
      value.value.length > 0 &&
      (Object.values(value.value).some((v) => v.checkState === true) ||
        (value.isIncludeOther === true &&
          !isNullOrUndefined(value.IncludeOtherText) &&
          value.IncludeOtherText !== ''))
    ) {
      setDispatch(
        dispatch,
        question.elementKey,
        value.value,
        '',
        value.isIncludeOther,
        value.IncludeOtherText,
      );

      return true;
    } else if (
      isNullOrUndefined(question.verifyOtherRegularExpression) &&
      question.mandatory === false
    ) {
      setDispatch(
        dispatch,
        question.elementKey,
        value.value,
        '',
        value.isIncludeOther,
        value.IncludeOtherText,
      );

      return true;
    } else {
      setDispatch(
        dispatch,
        question.elementKey,
        value.hasOwnProperty('value') ? value.value : [],
        validateMessageText,
        value.hasOwnProperty('isIncludeOther') ? value.isIncludeOther : false,
        value.hasOwnProperty('IncludeOtherText') ? value.IncludeOtherText : '',
      );
      return false;
    }
  }
};

export const validateRequireSetValueArrayAuto = (
  props,
  question,
  value,
  dispatch,
) => {
  // const { answer } = props;
  if (
    question.includeOther &&
    Array.isArray(value) &&
    value.length > 0 &&
    value[value.length - 1].checkState &&
    isNullOrUndefined(value[value.length - 1].choiceText) &&
    value[value.length - 1].choiceText !== ''
  ) {
    setDispatch(dispatch, question.elementKey, value, validateMessageText);

    return false;
  }
  if (
    question.mandatory &&
    Array.isArray(value) &&
    !Object.values(value).some((v) => {
      return v.checkState === true;
    })
  ) {
    setDispatch(dispatch, question.elementKey, value, validateMessageText);
    return false;
  } else {
    setDispatch(dispatch, question.elementKey, value, '');
  }

  return true;
};
export const validateRequireRatingScaleAuto = (
  props,
  value,
  dispatch,
  question,
) => {
  if (question.mandatory && value === '') {
    setDispatch(
      dispatch,
      question.elementKey,
      value.trim(),
      validateMessageText,
    );

    return false;
  }
  if (
    !isNullOrUndefined(question.verifyRegularExpression) &&
    question.verifyRegularExpression !== '' &&
    !isNullOrUndefined(value)
  ) {
    if (!new RegExp(question.verifyRegularExpression).test(value)) {
      setDispatch(
        dispatch,
        question.elementKey,
        value.trim(),
        verifyMessageText,
      );

      return false;
    }
  }

  if (isString(value)) {
    setDispatch(dispatch, question.elementKey, value.trim(), '');
  } else {
    setDispatch(dispatch, question.elementKey, value, '');
  }

  return true;
};
export const validateRequireAuto = (props, value, dispatch, question) => {
  if (question.mandatory && value.trim() === '') {
    setDispatch(
      dispatch,
      question.elementKey,
      value.trim(),
      validateMessageText,
    );

    return false;
  }
  if (
    !isNullOrUndefined(question.verifyRegularExpression) &&
    question.verifyRegularExpression !== '' &&
    !isNullOrUndefined(value)
  ) {
    if (!new RegExp(question.verifyRegularExpression).test(value)) {
      setDispatch(
        dispatch,
        question.elementKey,
        value.trim(),
        verifyMessageText,
      );
      return false;
    }
  }
  if (isString(value)) {
    setDispatch(dispatch, question.elementKey, value.trim(), '');
  } else {
    setDispatch(dispatch, question.elementKey, value, '');
  }

  return true;
};
export const validateRequireNpsAuto = (props, value, dispatch, question) => {
  if (question.mandatory && !isNumber(value)) {
    setDispatch(
      dispatch,
      question.elementKey,
      value.trim(),
      validateMessageText,
    );
    return false;
  }

  if (
    !isNullOrUndefined(question.verifyRegularExpression) &&
    question.verifyRegularExpression !== '' &&
    !isNullOrUndefined(value)
  ) {
    if (!new RegExp(question.verifyRegularExpression).test(value)) {
      setDispatch(dispatch, question.elementKey, value, verifyMessageText);

      return false;
    }
  }
  setDispatch(dispatch, question.elementKey, value, '');
  return true;
};
export const validateRequireEmailAuto = (props, value, dispatch, question) => {
  if (question.mandatory && value.trim() === '') {
    setDispatch(
      dispatch,
      question.elementKey,
      value.trim(),
      validateMessageText,
    );

    return false;
  }
  if (
    question.mandatory === false &&
    value.trim() !== '' &&
    !isNullOrUndefined(question.verifyRegularExpression) &&
    question.verifyRegularExpression !== '' &&
    !isNullOrUndefined(value)
  ) {
    if (!new RegExp(question.verifyRegularExpression).test(value)) {
      setDispatch(
        dispatch,
        question.elementKey,
        value.trim(),
        verifyMessageText,
      );

      return false;
    }
  }
  if (
    question.mandatory &&
    !isNullOrUndefined(question.verifyRegularExpression) &&
    question.verifyRegularExpression !== '' &&
    !isNullOrUndefined(value)
  ) {
    if (!new RegExp(question.verifyRegularExpression).test(value)) {
      setDispatch(
        dispatch,
        question.elementKey,
        value.trim(),
        verifyMessageText,
      );

      return false;
    }
  }
  setDispatch(dispatch, question.elementKey, value, '');

  return true;
};
export const validateRequirePhoneAuto = (props, value, dispatch, question) => {
  if (question.mandatory && value.trim() === '') {
    setDispatch(
      dispatch,
      question.elementKey,
      value.trim(),
      validateMessageText,
    );

    return false;
  }
  if (
    question.mandatory === false &&
    value.trim() !== '' &&
    !isNullOrUndefined(question.verifyRegularExpression) &&
    question.verifyRegularExpression !== '' &&
    !isNullOrUndefined(value)
  ) {
    if (!new RegExp(question.verifyRegularExpression).test(value)) {
      setDispatch(
        dispatch,
        question.elementKey,
        value.trim(),
        verifyMessageText,
      );

      return false;
    }
  }
  if (
    question.mandatory &&
    !isNullOrUndefined(question.verifyRegularExpression) &&
    question.verifyRegularExpression !== '' &&
    !isNullOrUndefined(value)
  ) {
    if (!new RegExp(question.verifyRegularExpression).test(value)) {
      setDispatch(
        dispatch,
        question.elementKey,
        value.trim(),
        verifyMessageText,
      );

      return false;
    }
  }
  setDispatch(dispatch, question.elementKey, value, '');

  return true;
};
export const validateRequireRatingAuto = (props, value, dispatch, question) => {
  if (question.mandatory && !isNumber(value) && value.trim() === '') {
    setDispatch(
      dispatch,
      question.elementKey,
      value.trim(),
      validateMessageText,
    );

    return false;
  }
  if (
    !isNullOrUndefined(question.verifyRegularExpression) &&
    question.verifyRegularExpression !== '' &&
    !isNullOrUndefined(value)
  ) {
    if (!new RegExp(question.verifyRegularExpression).test(value)) {
      setDispatch(
        dispatch,
        question.elementKey,
        value.trim(),
        verifyMessageText,
      );

      return false;
    }
  }

  if (isString(value)) {
    setDispatch(dispatch, question.elementKey, value.trim(), '');
  } else {
    setDispatch(dispatch, question.elementKey, value, '');
  }
  return true;
};

export const validateNumberRequireAuto = (props, value, dispatch, question) => {
  value = Number.parseFloat(value);
  if (question.mandatory && isNaN(value)) {
    setDispatch(dispatch, question.elementKey, value, validateMessageText);
    return false;
  }
  if (!isNaN(value) && question.maximumValue < value) {
    setDispatch(dispatch, question.elementKey, value, maximumMessageText);
    return false;
  } else if (!isNaN(value) && question.minimumValue > value) {
    setDispatch(dispatch, question.elementKey, value, minimumMessageText);
    return false;
  } else {
    setDispatch(dispatch, question.elementKey, value, '');
  }

  return true;
};
export const validateRankingRequireAuto = (
  props,
  value,
  dispatch,
  question,
) => {
  if (
    question.mandatory &&
    !isNumber(value) &&
    isArray(value) &&
    value.length === 0
  ) {
    setDispatch(dispatch, question.elementKey, value, validateMessageText);

    return false;
  } else {
    setDispatch(dispatch, question.elementKey, value, '');
  }
  return true;
};
export const dataPassValidate = (props, dispatch) => {
  const arrAnswers = [
    'F48C6761-41F6-4B45-AB48-52D7163A61BD',
    'DE5506A4-DB42-4619-9C5C-67A815E75FF8',
    '09943075-6104-4889-ACB8-126B9BE97D67',
    '2793D6A3-9B29-4B1A-B743-D270CCA4BE32',
    'E157B724-AEBA-4DDE-9F8C-93AEF06CD7D3',
    '54E410D2-205A-4E9F-AEE7-0557E95433DA',
    'D3EEC220-9F54-456E-ACC9-F543417D4DCA',
    '254CC22C-D2AE-46D4-984F-F333E679A762',
    'BA770694-B54A-45A0-A7A6-D5DFCC13BF02',
    'C8DAE34B-93D2-4196-B07E-6356DC788E81',
    '4CD52F8C-4D06-4E66-8BF3-3ED008088FCC',
    '49FB2B20-D6D9-4592-B0E7-2B90AB362E46',
    'CDE19227-5903-4A88-B44B-C074EF5A87F1',
    '9E1DD7A0-5E79-4A01-9A31-23A19111C8BF',
    '1DCB7714-772B-4B75-9212-739660FB8675',
  ];

  const { conduct, answers } = props;

  if ([WELCOME, THANKYOU].indexOf(conduct.node) >= 0) {
    return true;
  }
  let checkValidate = [];

  const context = Exp.survey_conduct_context(
    conduct.questions,
    answers,
    conduct.contextVariables,
  );
  let copyNodes = findQuestionInCurrentNode(
    props.nodes,
    conduct.questions,
    answers,
    context,
  );

  copyNodes.forEach((node, index) => {
    if (!validateConditionToRoot(node, context)) {
      return true;
    }
    let question = conduct.questions.filter((q, i) => {
      return q.elementKey === node.elementKey;
    });
    if (question[0]) {
      question = question[0];
      if (question.type === DISPLAYMESSAGE) {
        return true;
      }

      let answersKeys = Object.keys(props.answers);

      if (question && answersKeys.indexOf(question.elementKey) >= 0) {
        if (MULTIPLECHOICEONE === question.type) {
          let answerValues = props.answers[question.elementKey];
          if (!question.includeOther) {
            answerValues = props.answers[question.elementKey].value;
          }
          if (
            !validateRequireSetValueMultipleChoiceOneAuto(
              props,
              question,
              answerValues,
              dispatch,
            )
          ) {
            checkValidate.push(false);
          }
        } else if (MULTIPLECHOICEMULTIPLE === question.type) {
          let answerValues = props.answers[question.elementKey];
          if (!question.includeOther) {
            answerValues = props.answers[question.elementKey].value;
          }
          if (
            !validateRequireSetValueMultipleChoiceMultipleAuto(
              props,
              question,
              answerValues,
              dispatch,
            )
          ) {
            checkValidate.push(false);
          }
        } else if (MULTIPLECHOICESINGLELINETEXT === question.type) {
          let answerValues = props.answers[question.elementKey];
          if (!question.includeOther) {
            answerValues = props.answers[question.elementKey].value;
          }
          if (
            !validateRequireSetValueMultipleChoiceSinglelineTextAuto(
              props,
              question,
              answerValues,
              dispatch,
            )
          ) {
            checkValidate.push(false);
          }
        } else if (
          [
            MATRIXCHOICEMULTIPLE,
            MATRIXCHOICEONE,
            MATRIXSINGLELINETEXT,
            MATRIXDROPDOWN,
          ].indexOf(question.type) >= 0
        ) {
          if (
            !validateRequireSetValueArrayMatrixAuto(
              props,
              question,
              props.answers[question.elementKey].value,
              dispatch,
              question.type === MATRIXSINGLELINETEXT ||
                question.type === MATRIXDROPDOWN,
            )
          ) {
            checkValidate.push(false);
          }
        } else if (MATRIXRANKING === question.type) {
          if (
            !validateRequireSetValueArrayMatrixRankingAuto(
              props,
              question,
              props.answers[question.elementKey].value,
              dispatch,
            )
          ) {
            checkValidate.push(false);
          }
        } else if (RANKING === question.type) {
          if (
            !validateRankingRequireAuto(
              props,
              props.answers[question.elementKey].value,
              dispatch,
              question,
            )
          ) {
            checkValidate.push(false);
          }
        } else if (NUMBER === question.type) {
          if (
            !validateNumberRequireAuto(
              props,
              props.answers[question.elementKey].value,
              dispatch,
              question,
            )
          ) {
            checkValidate.push(false);
          }
        } else if (PHONE_SINGLELINETEXT === question.type) {
          if (
            !validateRequirePhoneAuto(
              props,
              props.answers[question.elementKey].value,
              dispatch,
              question,
            )
          ) {
            checkValidate.push(false);
          }
        } else if (EMAIL_SINGLELINETEXT === question.type) {
          if (
            !validateRequireEmailAuto(
              props,
              props.answers[question.elementKey].value,
              dispatch,
              question,
            )
          ) {
            checkValidate.push(false);
          }
        } else if (RATING === question.type) {
          if (
            !validateRequireRatingAuto(
              props,
              props.answers[question.elementKey].value,
              dispatch,
              question,
            )
          ) {
            checkValidate.push(false);
          }
        } else if (RATINGSCALE === question.type) {
          if (
            !validateRequireRatingScaleAuto(
              props,
              props.answers[question.elementKey].value,
              dispatch,
              question,
            )
          ) {
            checkValidate.push(false);
          }
        } else if (NETPROMOTORSCORE === question.type) {
          if (
            !validateRequireNpsAuto(
              props,
              props.answers[question.elementKey].value,
              dispatch,
              question,
            )
          ) {
            checkValidate.push(false);
          }
        } else {
          if (
            !validateRequireAuto(
              props,
              props.answers[question.elementKey].value,
              dispatch,
              question,
            )
          ) {
            checkValidate.push(false);
          }
        }
      } else if (question && answersKeys.indexOf(question.elementKey) < 0) {
        if (MULTIPLECHOICEONE === question.type) {
          let data = [];
          if (question.includeOther) {
            data = {
              isIncludeOther: false,
              IncludeOtherText: null,
              value: [],
            };
          }
          if (
            !validateRequireSetValueMultipleChoiceOneAuto(
              props,
              question,
              data,
              dispatch,
            )
          ) {
            checkValidate.push(false);
          }
        } else if (MULTIPLECHOICEMULTIPLE === question.type) {
          let data = [];
          if (question.includeOther) {
            data = {
              isIncludeOther: false,
              IncludeOtherText: null,
              value: [],
            };
          }
          if (
            !validateRequireSetValueMultipleChoiceMultipleAuto(
              props,
              question,
              data,
              dispatch,
            )
          ) {
            checkValidate.push(false);
          }
        } else if (MULTIPLECHOICESINGLELINETEXT === question.type) {
          let data = [];
          if (question.includeOther) {
            data = {
              isIncludeOther: false,
              IncludeOtherText: null,
              value: [],
            };
          }
          if (
            !validateRequireSetValueMultipleChoiceSinglelineTextAuto(
              props,
              question,
              data,
              dispatch,
            )
          ) {
            checkValidate.push(false);
          }
        } else if (
          [
            MATRIXCHOICEMULTIPLE,
            MATRIXCHOICEONE,
            MATRIXSINGLELINETEXT,
            MATRIXDROPDOWN,
          ].indexOf(question.type) >= 0
        ) {
          if (
            !validateRequireSetValueArrayMatrixAuto(
              props,
              question,
              [],
              dispatch,
              question.type === MATRIXSINGLELINETEXT ||
                question.type === MATRIXDROPDOWN,
            )
          ) {
            checkValidate.push(false);
          }
        } else if (MATRIXRANKING === question.type) {
          if (
            !validateRequireSetValueArrayMatrixRankingAuto(
              props,
              question,
              [],
              dispatch,
            )
          ) {
            checkValidate.push(false);
          }
        } else if (RANKING === question.type) {
          if (!validateRankingRequireAuto(props, [], dispatch, question)) {
            checkValidate.push(false);
          }
        } else if (NUMBER === question.type) {
          if (!validateNumberRequireAuto(props, '', dispatch, question)) {
            checkValidate.push(false);
          }
        } else if (PHONE_SINGLELINETEXT === question.type) {
          if (!validateRequirePhoneAuto(props, '', dispatch, question)) {
            checkValidate.push(false);
          }
        } else if (EMAIL_SINGLELINETEXT === question.type) {
          if (!validateRequireEmailAuto(props, '', dispatch, question)) {
            checkValidate.push(false);
          }
        } else if (RATING === question.type) {
          if (!validateRequireRatingAuto(props, '', dispatch, question)) {
            checkValidate.push(false);
          }
        } else if (RATINGSCALE === question.type) {
          if (!validateRequireRatingScaleAuto(props, '', dispatch, question)) {
            checkValidate.push(false);
          }
        } else if (NETPROMOTORSCORE === question.type) {
          if (!validateRequireNpsAuto(props, '', dispatch, question)) {
            checkValidate.push(false);
          }
        } else {
          if (!validateRequireAuto(props, '', dispatch, question)) {
            checkValidate.push(false);
          }
        }
      }
    }
  });
  if (
    // check validate
    checkValidate.some((v) => {
      return v === false;
    })
  ) {
    if (
      conduct.currentNode.elementKey === '748C8E3D-D149-4A56-A90B-23D838F7D9B7'
    ) {
      let filterAnswers = Object.keys(answers)
        .filter((key) => arrAnswers.includes(key)) // กรองเฉพาะ key ที่อยู่ใน arrAnswers
        .reduce((acc, key) => {
          acc[key] = answers[key]; // เก็บค่า answers ที่มี key ตรงกัน
          return acc;
        }, {});

      if (Object.keys(filterAnswers).length >= 2) {
        const hasValueWithTwoOrMore = Object.values(filterAnswers).map(
          (item) =>
            item.value !== '' &&
            item.value !== undefined &&
            item.value !== null,
        );

        // if มี true มากกว่า= 2 รายการ
        if (hasValueWithTwoOrMore.filter((item) => item === true).length >= 2) {
          return true;
        } else {
          return false;
        }
      } else {
        const questions = document.querySelectorAll('.question.rating.scale');
        if (questions.length >= 2) {
          return false;
        }
        // เช็คว่ามีค่า value อยู่ใน filterAnswers หรือไม่
        const hasValue = Object.values(filterAnswers).some(
          (item) =>
            item.value !== '' &&
            item.value !== undefined &&
            item.value !== null,
        );

        if (hasValue) {
          return true;
        } else {
          return false;
        }
      }
    }
    //return funtcion
    return false;
  }
  //return funtcion
  return true;
};
